
import * as React from "react"
import { cn } from "@/lib/utils"
import { Typography, type TypographyProps } from "./base"

// Card title variant
export const CardTitle = React.forwardRef<HTMLHeadingElement, Omit<TypographyProps, "as">>(
  ({ className, size = "h3", weight = "semibold", ...props }, ref) => (
    <Typography
      ref={ref}
      as="h3"
      size={size}
      weight={weight}
      className={cn("tracking-tight", className)}
      {...props}
    />
  )
)
CardTitle.displayName = "CardTitle"

// Card description variant
export const CardDescription = React.forwardRef<HTMLParagraphElement, Omit<TypographyProps, "as" | "variant">>(
  ({ className, size = "small", ...props }, ref) => (
    <Typography
      ref={ref}
      as="p"
      variant="muted"
      size={size}
      className={className}
      {...props}
    />
  )
)
CardDescription.displayName = "CardDescription"
